<template>
  <div class="write-data-item-wrap pl-4 pr-4 pt-3 pb-3 flex flex-col bg-white text-14px ">
    <div class="flex flex-row items-center justify-between">
      <img :src="flavorInfo.brandPicture"  style="flex:1;height:20px;object-fit: contain;object-position: left"/>
      <div class=" third-color text-right" style="flex:2">{{ flavorInfo.createTime }}</div>
<!--      <div class="flex flex-col third-color text-left">-->
<!--      </div>-->
    </div>
    <div class="radius-border flex flex-row p-3">
      <van-image :src="flavorInfo.flavorPicture" fit="contain" class="flavor-icon"/>
      <div class="flavor-name-tag">
        <div class="flavor-name text-left">{{ flavorInfo.flavorName }}</div>
        <div class="flavor-tag-content">
          <span v-for="(tag,index) in flavorInfo.labelList" :key="index" class="flavor-tag">{{ tag }}</span>
        </div>
      </div>
    </div>

    <div style="margin-top:8px">
      <InfoRow v-for="(item,index) in scanInfo" :key="index" :label="item.label" :value="item.value"/>
    </div>
  </div>
</template>

<script>
import InfoRow from "@/components/InfoRow.vue";

export default {
  name: "WriteDataItem",
  components: { InfoRow },
  props: {
    flavorInfo :{
      type:Object,
      default:()=> {}
    },
    scanInfo: {
      type:Array,
      default:()=> {
        return []
      }
    }
  },
  data() {
    return {
      flavor: {
        flavorName: "Grape",
        labelList: [{ labelName: "123" }, { labelName: "123" }, { labelName: "123" }]
      }
    };
  },
  computed: {
    codeDeviceInfo() {
      const info = [];
      info.push({ label: "Quantity", value: "20 boxes" });
      info.push({ label: "Model", value: "292636106520" });
      return info;
    }
  }
};
</script>


<style scoped lang="less">
.write-data-item-wrap {
  border-radius: 12px;
  & > * + * {
    margin-top: 12px;
  }
}

.flavor-icon {
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
  border-radius: 10px;
}

.flavor-name-tag {
  margin-left: 10px;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-x: scroll;

  .flavor-name {
    font-size: 14px;
  }

  .flavor-tag-content {
    margin-top: 10px;
    display: flex;
    flex: 1;
    font-size: 10px;
    flex-direction: row;
    align-items: center;
    overflow-x: scroll;

    .flavor-tag {
      border-radius: 8px;
      background: #F1F6FF !important;
      color: #333333 !important;
      padding: 4px 8px;
      margin-right: 4px;
    }
  }
}
.info-row {
  & > *:not(:first-child) {
    margin-top: 6px;
  }
}
</style>